import React from 'react'
import { Tag } from 'antd'
import {
  RelationCard,
  RelationHeader,
  RelationTitle,
  RelationInfo,
  RelationInfoRow,
  RelationInfoCol,
  RelationInfoLabel,
  RelationInfoValue,
} from './styles'

interface RelationCardViewProps {
  title: string
  onClick?: () => void
  info: Array<{ label: string; value: React.ReactNode }>
  stage?: { name: string; style?: React.CSSProperties }
  headerContent?: React.ReactNode
}

export const RelationCardView: React.FC<RelationCardViewProps> = ({
  title,
  onClick,
  info,
  stage,
  headerContent,
}) => (
  <RelationCard
    $clickable={Boolean(onClick)}
    onClick={onClick}
    role={onClick ? 'link' : undefined}
    tabIndex={onClick ? 0 : undefined}
    onKeyDown={event => {
      if (event.key === 'Enter') onClick?.()
    }}
  >
    <RelationHeader>
      <RelationTitle>{title}</RelationTitle>
      {headerContent}
    </RelationHeader>
    {(stage || info.length > 0) && (
      <RelationInfo>
        <RelationInfoRow>
          {stage && (
            <RelationInfoCol>
              <RelationInfoLabel>Стадия</RelationInfoLabel>
              <RelationInfoValue>
                <Tag style={stage.style}>{stage.name}</Tag>
              </RelationInfoValue>
            </RelationInfoCol>
          )}
          {info.map((item, index) => (
            <RelationInfoCol key={`${item.label}-${index}`}>
              <RelationInfoLabel>{item.label}</RelationInfoLabel>
              <RelationInfoValue>{item.value}</RelationInfoValue>
            </RelationInfoCol>
          ))}
        </RelationInfoRow>
      </RelationInfo>
    )}
  </RelationCard>
)
